export default __webpack_public_path__ + "static/media/upcoming_guest.951fdeb1.png";